module.exports = __webpack_public_path__ + "static/media/male.d6c98437.svg";